import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import './App.css';

// Composants
import Header from './components/Header';
import Home from './components/Home';
import Events from './components/Events';
import EventDetail from './components/EventDetail';
import Footer from './components/Footer';
import UserList from './components/UserList';

// Thème personnalisé avec les couleurs rouges élégantes
const theme = createTheme({
  palette: {
    primary: {
      main: '#FF6B6B', // Rouge corail
      dark: '#E53E3E',
      light: '#FF8E8E',
    },
    secondary: {
      main: '#ffffff', // Blanc
    },
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 600,
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="" element={<Home />} />
            <Route path="events" element={<Events />} />
            <Route path="event/:id" element={<EventDetail />} />
            <Route path="user-list" element={<UserList />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default App;
